import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpCreateTreatmentRequest, HttpCreateTreatmentRequestPayload} from './treatment-requests.http'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError} from 'axios'
import {FormErrorResponse} from '@/types'
import {TreatmentRequestSmall} from '@/features/treatment-requests/types'

export const useCreateTreatmentRequest = (
    options?: UseMutationOptions<
        TreatmentRequestSmall,
        AxiosError<{errors: FormErrorResponse[]}>,
        HttpCreateTreatmentRequestPayload
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_TREATMENT_REQUEST],
        mutationFn: httpCreateTreatmentRequest
    })
}
